import { createContext } from 'react';

interface LayerContextValue {
    id?: number;
    isTopLayer: boolean;
}

export const LayerContext = createContext<LayerContextValue>({ isTopLayer: false });
